<template>
  <div>
    <Header />
    <div class="siteError">
      <p class="siteError__text">Oh, tut uns leid. Diese Seite konnte nicht gefunden werden.</p>
      <p><router-link to="/" class="siteError__link">Home</router-link></p>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer/Main.vue'

export default {
  name: 'PageNotFound',
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="scss">
  .siteError {
    margin: 90px auto 160px auto;
    overflow: hidden;
    padding: 1%;
    text-align: left;
    width: 90%;
  }
</style>
